import { Country } from "@goodgamestudios/world-assignment";

import Event = createjs.Event;

export class CountrySelectComponentEvent extends Event {
    public static COUNTRY_VIEW_OPENED: string = "countryViewOpened";
    public static COUNTRY_VIEW_CLOSED: string = "countryViewClosed";
    public static COUNTRY_CHANGED: string = "countryChanged";

    public selectedCountry: Country;

    constructor(type: string, selectedCountry: Country = null, bubbles: boolean = true, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
        this.selectedCountry = selectedCountry;
    }
}

